import { HeartIcon } from "@heroicons/react/24/outline";
import {
  SectionEmptyState,
  SectionHeader,
  SectionPanel,
} from "../../../componentLibrary/SectionPanel";
import Tag from "../../../componentLibrary/Tag";
import type {
  ModuleI,
  ToolboxProfileDefinitionI,
  UserToolboxProfileI,
} from "../../../types";

interface Props {
  topic: ModuleI;
  definition: ToolboxProfileDefinitionI | undefined;
  userProfile: UserToolboxProfileI | undefined;
}

export default function AboutMyTopicPanel({
  topic,
  definition,
  userProfile,
}: Props) {
  const title =
    topic.slug === "anxiety" ? "About The Anxiety" : `About My ${topic.title}`;

  const hasAnswers =
    !!userProfile && Object.keys(userProfile.answers).length > 0;

  return (
    <SectionPanel>
      <SectionHeader
        icon={<HeartIcon className="w-5 h-5 text-electrum-300 shrink-0" />}
        title={title}
        action="Update"
        actionTo="profile"
      />
      {hasAnswers && definition ? (
        <ul className="space-y-3">
          {definition.questions.map((q) => {
            const answer = userProfile!.answers[q.variableName];
            if (
              answer === undefined ||
              answer === "" ||
              (Array.isArray(answer) && answer.length === 0)
            )
              return null;
            const formatAnswer = () => {
              if (
                q.type === "rating_scale" &&
                "scale" in q.content &&
                q.content.scale
              )
                return [`${String(answer)} / ${q.content.scale}`];
              return Array.isArray(answer)
                ? answer.map(String)
                : [String(answer)];
            };
            const items = formatAnswer();
            const visible = items.slice(0, 3);
            const rest = items.length - visible.length;
            return (
              <li key={q.questionId}>
                {q.content?.label && (
                  <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-1.5">
                    {q.content.label}
                  </p>
                )}
                <div className="flex flex-wrap gap-1.5">
                  {visible.map((a) => (
                    <Tag key={a}>{a}</Tag>
                  ))}
                  {rest > 0 && <Tag variant="neutral">+{rest}</Tag>}
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <SectionEmptyState>
          <p className="text-sm text-gray-400 py-2">
            Information about your {topic.title} toolbox will appear here.
          </p>
        </SectionEmptyState>
      )}
    </SectionPanel>
  );
}
